import(/* webpackMode: "eager", webpackExports: ["LegalPage"] */ "/Users/princemendiratta/Documents/startup/ws/tree-1/apps/frontend/src/components/legal/legal-page.tsx");
